import { render, staticRenderFns } from "./CourseDayFiltersChips.vue?vue&type=template&id=e1c6ff4c&lang=pug&"
import script from "./CourseDayFiltersChips.vue?vue&type=script&lang=js&"
export * from "./CourseDayFiltersChips.vue?vue&type=script&lang=js&"
import style0 from "./CourseDayFiltersChips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
